export const mentionTagStyle = {
  backgroundColor: 'rgb(27, 149, 224)'
}

export const mentionInputStyle = {
  control: {
    backgroundColor: '#fff',

    fontSize: 12,
    fontWeight: 'normal'
  },

  highlighter: {
    overflow: 'hidden'
  },

  input: {
    margin: 0
  },

  '&singleLine': {
    control: {
      display: 'inline-block',

      width: 130
    },

    highlighter: {
      padding: 1,
      border: '2px inset transparent'
    },

    input: {
      padding: 1,

      border: '2px inset'
    }
  },

  '&multiLine': {
    control: {
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
      borderRadius: 3,
      fontSize: 15,
      minHeight: 90
    },

    highlighter: {
      paddingTop: 16,
      paddingBottom: 16,
      paddingLeft: 18,
      paddingRight: 18,
      lineHeight: 1.5,
      border: 0
    },

    input: {
      paddingTop: 16,
      paddingBottom: 16,
      paddingLeft: 18,
      paddingRight: 18,
      minHeight: 68,
      outline: 0,
      border: 0,
      lineHeight: 1.5
    }
  },

  suggestions: {
    list: {
      backgroundColor: 'transparent',
      fontSize: 14,
      borderRadius: 2
    },

    item: {
      padding: '5px 10px',
      borderBottom: '1px solid rgba(0,0,0,0.15)',

      '&focused': {
        backgroundColor: '#cee4e5'
      }
    }
  }
}
export const mentionInputDisabledStyle = {
  ...mentionInputStyle,
  control: {
    ...mentionInputStyle.control,
    backgroundColor: 'rgb(243 243 243)'
  },
  '&multiLine': {
    ...mentionInputStyle['&multiLine'],
    control: {
      ...mentionInputStyle['&multiLine'].control,
      color: '#aaa'
    },
    input: {
      ...mentionInputStyle['&multiLine'].input,
      opacity: 0.8,
      pointerEvents: 'none'
    }
  }
}
